import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogramarchived/marsperiod/";

export default class MarsPeriodApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getMarsPeriods(params) {
    return await request.post(`${rootRoute}getMarsPeriods`, {
      filter: params,
      parameters: {},
    });
  }
  async getMarsPeriod(id) {
    return await request.post(`${rootRoute}getMarsPeriods`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async createMarsPeriod(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createMarsPeriod`, { data });
  }
  async deleteMarsPeriod(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteMarsPeriod`, { data });
  }
  async editMarsPeriod(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateMarsPeriod`, { data });
  }
  async import(gfid) {
    return await request.post(`${rootRoute}importMarsPeriod`, {
      gfid: gfid
    });
  }
  async getImportScaffold() {
    return await request.post(`${rootRoute}getMarsPeriodimporttemplate`, null, {responseType: 'blob'});
  }
  async export(filter, format) {
    return await request.post(`${rootRoute}exportMarsPeriod`, {
      filter: filter,
      format: format
    });
  }
  async close(marsperiodId) {
    return await request.post(`${rootRoute}closemarsperiod`, {
      id: marsperiodId
    });
  }
  async blockMarsPeriod(model) {
    return await request.post(`${rootRoute}blockmarsperiod`, model);
  }
}
